/**
 * Parcels Sender
 */

// React
import React, {FunctionComponent, useEffect, useState, useContext} from 'react';

// Context
import AuthContext from '../../authContext';

import {useForm} from 'react-hook-form';
// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getParcelsAction,
  updateParcelsActions,
  createParcelsActions,
  updateParcelsStatusActions,
  deleteParcelAction,
  cancelParcelAction,
  getAllParcelsReportAction,
} from '../parcels/actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectLocatedCardCountList,
  makeSelectSubmmitedCardCountList,
  makeSelectProgressCardCountList,
  makeSelectConflictCardCountList,
  makeSelectAllParcels,
} from '../parcels/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import Add from './components/Add/add';
import Edit from './components/Edit/edit';
import Modal from '../../components/Modal';
import Can from '../../components/Can';

import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import {
  ArgumentAxis,
  ValueAxis,
  Chart,
  LineSeries,
  Tooltip,
} from '@devexpress/dx-react-chart-material-ui';
import {EventTracker} from '@devexpress/dx-react-chart';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  InputBase,
  ClickAwayListener,
  FormControl,
  Select,
  Card,
  CardHeader,
  CardContent,
  MenuItem,
  TextField,
  Paper,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiWarehouse,
  mdiMagnify,
  mdiCheck,
  mdiClose,
  mdiCalendar,
  mdiCalendarClock,
  mdiKeyOutline,
  mdiStateMachine,
  mdiPackageVariantClosed,
  mdiPlus,
  mdiPencilOutline,
  mdiClipboardMultipleOutline,
  mdiDresser, mdiPackageVariant,
} from '@mdi/js';
import {Clipboard, Invoice, Pallet, Stock} from './customIcon';

// Helper
import {
  removeEmptyValueObject,
  translateParcelsStatus,
} from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  PayloadUpdate,
  PayloadCreate,
  Status,
} from './interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';
import jMoment from 'moment-jalaali';
import CSV from './csv';
import {Link} from 'react-router-dom';
import {Payload} from '../orders/interfaces';
import {getAllOrdersReportAction} from '../orders/actions';
import useQuery from '../../utils/hook/useQuery';

type Inputs = {
  'id.contains': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      transform: 'translateY(-3px)',
      boxShadow: '-4px 4px 12px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-10px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-35px',
    },
    errorText: {
      paddingTop: '1em',
      fontSize: '0.875rem',
      textAlign: 'left',
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    mdiDresserIcon: {
      color: '#329926',

      // backgroundColor: '#D6EBD3',
    },
    mdiClipboardMultipleOutlineIcon: {
      color: '#6276F7',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Parcels: FunctionComponent<Props> = (props: Props) => {
  const {register, handleSubmit} = useForm<Inputs>();
  const authContext = useContext(AuthContext);
  const [openFilterBox, setOpenFilterBox] = useState(false as boolean);
  const [cancelReason, setCancelReason] = useState<string>('');
  const [disableCancelParcelModal, setDisableCancelParcelModal] = useState(
    false as boolean
  );
  const [inputError, setInputError] = useState(false as boolean);

  console.log("salam")

  const data = [
    {argument: 'امروز', value: 0},
    {argument: '۱ روز قبل', value: 200},
    {argument: '۲ روز قبل', value: 60},
    {argument: '۳ روز قبل', value: 20},
    {argument: '۴ روز قبل', value: 150},
    {argument: '۶ روز قبل', value: 200},
  ];

  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  });
  const [filters, setFilters] = useState([] as Filter[]);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [openAdd, setOpenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);

  useEffect(() => {
    getParcels();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getParcels = () => {
    const {page, size} = filtersValues;
    const {warehouseId} = authContext.user;
    const {partnerId} = authContext.user;

    props.parcelsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: partnerId ? {equals: partnerId} : undefined, // partner_id => partner_admin role
      sourceWarehouseId: warehouseId ? {equals: warehouseId} : undefined, // WHId
      page,
      size,
    });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleOpen = (id: number, type: string) => {
    // setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setOpenAdd(false);
    setOpenSize(false);
  };
  const handleCardClose = () => {
    const {page, size} = filtersValues;
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };

  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
    setOpenConfirmUpdateState(true);
    setPreviewState(data.body);
  };

  const onSubmit = (filterValues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filterValues),
      page: 0,
      size: 10,
    });
    setOpenFilterBox(false);
  };

  const handleClickAway = (e: any) => {
    // TODO: Sheet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleDisableCancelModal = () => {
    setDisableCancelParcelModal(false);
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'destinationWarehouseName.contains',
        label: 'انبار مقصد',
        icon: mdiWarehouse,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه محموله',
        icon: mdiKeyOutline,
      },
      {
        type: 'date-picker',
        id: 'shippingDate.greaterThanOrEqual',
        label: 'تاریخ ثبت محموله از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: 'تا تاریخ ثبت محموله ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: 'تا تاریخ تحویل',
        icon: mdiCalendar,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت محموله',
        data: ['SUBMITTED', 'SHIPPED', 'DELIVERED', 'CANCELLED'],
        translateType: 'parcel',
        icon: mdiStateMachine,
      },
    ]);
  };

  const handleDisable = async () => {
    try {
      if (validateRequiredInput(cancelReason)) {
        await props.cancelParcelDispatch({
          id,
          body: cancelReason,
        });
        setOpenConfirmDisable(false);
        setCancelReason('');
      }
    } catch (err) {}
  };

  const validateParcelStatus = (id: number) => {
    const parcel = props.parcelsList.find(item => item.id === id);
    return !!(parcel && parcel.status === 'SUBMITTED');
  };

  const handleCancelParcelReason = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    if (validateRequiredInput(target.value)) {
      setCancelReason(target.value.trim());
    }
  };

  const validateRequiredInput = (value: string) => {
    if (value.trim().length > 0) {
      if (inputError) {
        setInputError(false);
      }
      return true;
    } else {
      setInputError(true);
      return false;
    }
  };

  const handleOpenConfirmDisable = (id: number) => {
    setId(id);
    if (validateParcelStatus(id)) {
      setOpenConfirmDisable(true);
    } else {
      setDisableCancelParcelModal(true);
    }
  };

  const changeStatusParcel = () => {
    const {warehouseId} = authContext.user;
    const params = warehouseId
      ? {
          sourceWarehouseId: {equals: warehouseId},
        }
      : {...filtersValues};

    props.updateParcelsStatusDispatch({
      id,
      body: {status: previewState, description: ''},
      pagination: params,
    });
    setOpenConfirmUpdateState(false);
  };

  const findStatus = (id: number) => {
    const status = props.parcelsList.find(parcel => parcel.id === id)
      ?.status as Status;
    return status && translateParcelsStatus(status);
  };
  const handleCardClick = (name: any) => {
    const {page, size} = filtersValues;

    switch (name) {
      case 'located':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['LOCATED'],

          page: 0,
          size: 10,
        });
        break;
      case 'progress':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['UNLOADING', 'ASSIGNED', 'UNLOADED', 'REGISTERED'],
          page: 0,
          size: 10,
        });
        break;
      case 'submitted':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['SUBMITTED'],
          page: 0,
          size: 10,
        });
        break;
      case 'conflicted':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['CONFLICTED'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'progress':
        return (
          status.includes('UNLOADING') &&
          status.includes('ASSIGNED') &&
          status.includes('UNLOADED') &&
          status.includes('REGISTERED')
        );
      case 'submitted':
        return status.includes('SUBMITTED');
      case 'located':
        return status.includes('LOCATED');
      case 'conflicted':
        return status.includes('CONFLICTED');
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h4" component="h2">
            {'ارسال محموله‌'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه محموله',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid container item xs={12} direction="row-reverse">
          <Can
            role={authContext.user.role}
            perform="parcels:addParcel"
            yes={() => (
              <Link
                to="/parcels-exit/add"
                style={{marginLeft: '10px', textDecoration: 'none'}}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  startIcon={<Icon path={mdiPlus} size={1} />}
                >
                  {'ایجاد محموله جدید'}
                </Button>
              </Link>
            )}
          />
        </Grid>
      </Grid>
      <Grid style={{marginBottom: '10px'}} container xs={12} justify="flex-end">
        <Can
          role={authContext.user.role}
          perform="parcels:createNewParcel"
          yes={() => (
            <Link
              to="/parcels-sender/add"
              style={{marginLeft: '10px', textDecoration: 'none'}}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPlus} size={1} />}
              >
                {'ایجاد محموله جدید'}
              </Button>
            </Link>
          )}
        />{' '}
        <Can
          role={authContext.user.role}
          perform="parcels:downloadReportCSV"
          yes={() => (
            <>
              <CSV
                parcelsDispatch={props.allParcelsDispatch}
                data={props.allParcels}
                filtersValues={filtersValues}
                loading={props.loading}
              />
            </>
          )}
        />
      </Grid>
      <Grid
        container
        spacing={2}
        md={12}
        style={{
          // justifyContent: 'space-between',
          maxWidth: '120%',
          margin: '32px 1px',
        }}
      >
        <Grid container item lg={12} spacing={2} xs={12}>
          <Grid item md={6} lg={3} xs={6}>
            <Card
              className={
                checkActiveCard('submitted') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('submitted') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  onClick={name => handleCardClick('submitted')}
                  aria-label="search"
                  style={{
                    backgroundColor: '#DFE3FD',
                    height: '50%',
                    width: '27%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                >
                  <Clipboard />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{fontWeight: 600, marginTop: '-20px'}}
                  >
                    {props.submittedCardCount}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginTop: '30px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    ایجاد شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} lg={3} xs={6}>
            <Card
              className={
                checkActiveCard('progress') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('progress') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  aria-label="search"
                  onClick={name => handleCardClick('progress')}
                  style={{
                    padding: '17px 0',
                    backgroundColor: '#FFEDDE',
                    height: '60%',
                    width: '27%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                >
                  <Pallet />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{fontWeight: 600, marginTop: '-20px'}}
                  >
                    {props.progressCardCount}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginTop: '30px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    در حال پردازش
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} lg={3} xs={6}>
            <Card
              className={
                checkActiveCard('located') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('located') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  aria-label="search"
                  onClick={name => handleCardClick('located')}
                  style={{
                    backgroundColor: '#D6EBD3',
                    height: '60%',
                    width: '27%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                >
                  <Stock />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{fontWeight: 600, marginTop: '-20px'}}
                  >
                    {props.locatedCardCount}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginTop: '30px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    جایگذاری شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item md={6} lg={3} xs={6}>
            <Card
              className={
                checkActiveCard('conflicted')
                  ? classes.boxshadow
                  : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('conflicted') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />

              <CardContent className={classes.cardContent}>
                <IconButton
                  type="submit"
                  aria-label="search"
                  onClick={name => handleCardClick('conflicted')}
                  style={{
                    backgroundColor: '#FCD4DA',
                    height: '60%',
                    width: '26%',
                    borderRadius: '4px',
                    margin: '-20px 0',
                  }}
                >
                  <Invoice />
                </IconButton>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{fontWeight: 600, marginTop: '-20px'}}
                  >
                    {props.conflictCardCount}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: '16px',
                      marginTop: '30px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    دارای مغایرت
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* <Grid item lg={4} xs={6}>
          <Card className={classes.chart}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography className={classes.typographyCards}>
                تعداد آیتم‌های محموله
              </Typography>
              <Select value={'۷ روز گذشته'}>
                <MenuItem value={'۷ روز گذشته'}>۷ روز گذشته</MenuItem>
              </Select>
            </Grid>
            <div style={{marginTop: '10px'}}>
              <Chart data={data} height={230}>
                <ArgumentAxis />
                <ValueAxis position={'right'} />

                <LineSeries valueField="value" argumentField="argument" />
                <EventTracker />
                <Tooltip />
              </Chart>
            </div>
          </Card>
        </Grid> */}
        {/* <Grid item lg={3} xs={6}>
          <Card className={classes.progress}>
            <Typography
              className={classes.typographyCards}
              style={{
                width: '60%',
                textAlign: 'end',
              }}
            >
              محموله هر انبار
            </Typography>
            <div style={{textAlign: 'center', margin: '30px auto'}}>
              <CircularProgress
                size={140}
                style={{
                  position: 'relative',
                  color: '#6276F7',
                  // bottom: '-20%',
                  // right: '30%',
                }}
                variant="determinate"
                value={60}
                thickness={6}
              />
              <Typography
                style={{
                  position: 'relative',
                  bottom: '85px',
                  fontWeight: 900,
                }}
                variant="caption"
                component="div"
                color="textSecondary"
              >
                {'754 سفارش'}
              </Typography>
            </div>
          </Card>
        </Grid> */}
      </Grid>
      <Grid container spacing={3} style={{marginTop: '32px'}}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {props.parcelsList.length > 0 ? (
                <List
                  data={props.parcelsList}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpen={handleOpen}
                  changeStatus={handleOpenConfirmUpdateState}
                />
              ) : (
                <Typography variant="h3" component="div">
                  محموله موجود نیست
                </Typography>
              )}
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.parcelsList.length > 0 && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleClose}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.parcelsList.length > 0 && (
            <Pagination
              className={classes.pagination}
              count={Math.ceil(props.count / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
      </Grid>

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={handleClose}
        open={openAdd}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            warehouseId={props.match.params.id}
            onClose={handleClose}
            create={body => {
              props.createParcelsDispatch({
                body,
                pagination: {
                  ...filtersValues,
                  sourceWarehouseId: {equals: authContext.user?.warehouseId},
                },
              });
              handleClose();
            }}
          />
        }
      />

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={handleClose}
        open={openDialog}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Edit
            warehouseId={props.match.params.id}
            data={props.parcelsList?.find(item => item.id === id)}
            onClose={handleClose}
            create={body => {
              props.updateParcelsDispatch({
                body,
                pagination: {
                  ...filtersValues,
                  sourceWarehouseId: {equals: authContext.user?.warehouseId},
                },
                id: props.match.params.id,
              });
              handleClose();
            }}
          />
        }
      />

      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleClose}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            لغو محموله با شناسه
          "${props.parcelsList.find(item => item.id === id)?.id}"
          مطمئن هستید؟`}

            <Grid item xs={12}>
              <TextField
                fullWidth
                id="cancelDescription"
                name="cancelDescription"
                label="علت لغو"
                error={inputError}
                onChange={handleCancelParcelReason}
              />
              {inputError && (
                <Typography
                  component="p"
                  align="right"
                  className={classes.errorText}
                  color="error"
                >
                  علت لغو الزامی میباشد.
                </Typography>
              )}
            </Grid>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleDisable}
                disabled={inputError}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={disableCancelParcelModal}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleDisableCancelModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`
              امکان لغو محموله "${
                props.parcelsList.find(item => item.id === id)?.id
              }" در وضعیت فعلی وجود ندارد.
               
در صورت نیاز به اطلاعات بیشتر با پشتیبانی تماس حاصل فرمایید.              
            `}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                autoFocus
                onClick={handleDisableCancelModal}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت محموله
                با شناسه  ${id} از
 "${id > -1 && findStatus(id)}"
 به
" ${translateParcelsStatus(previewState.replace(/"/g, '') as Status)}"

 
 مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusParcel}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  parcelsList: makeSelectList(),
  allParcels: makeSelectAllParcels(),
  count: makeSelectCountList(),
  locatedCardCount: makeSelectLocatedCardCountList(),
  submittedCardCount: makeSelectSubmmitedCardCountList(),
  progressCardCount: makeSelectProgressCardCountList(),
  conflictCardCount: makeSelectConflictCardCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    parcelsDispatch: (payload: Record<string, any>) =>
      dispatch(getParcelsAction(payload)),
    allParcelsDispatch: (payload: Payload) =>
      dispatch(getAllParcelsReportAction(payload)),
    updateParcelsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateParcelsActions(payload)),
    createParcelsDispatch: (payload: PayloadCreate) =>
      dispatch(createParcelsActions(payload)),
    deleteParcelDispatch: (payload: {id: number}) =>
      dispatch(deleteParcelAction(payload)),
    updateParcelsStatusDispatch: (payload: {
      id: number;
      body: object;
      pagination: object;
    }) => dispatch(updateParcelsStatusActions(payload)),
    cancelParcelDispatch: (payload: {id: number; body: string}) =>
      dispatch(cancelParcelAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Parcels);
